import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
  onActionEditar: (
    Id: number | null,
    openState: boolean,
    openAnalise: boolean,
  ) => void;
  onActionDeletar: (Id: number | null, openState: boolean) => void;
  read: boolean;
};

export const GenerateParalisacoesColumns = ({
  onActionEditar,
  onActionDeletar,
  read,
}: Props): GridColDef[] => {
  return [
    {
      field: "Motivo",
      filterable: false,
      headerName: "Motivo",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-all w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Assunto",
      filterable: false,
      headerName: "Assunto",
      flex: 1,
      minWidth: 250,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-all w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "HorarioInicio",
      filterable: false,
      headerName: "Horario Inicio",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "HorarioFim",
      filterable: false,
      headerName: "Horario Fim",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "TempoParalisacao",
      filterable: false,
      headerName: "Tempo Paralisação",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "IdDiarioObrasParalisacoes",
      sortable: false,
      filterable: false,
      headerName: "Ações",
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        if (read !== false) return null;

        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onClick={() => onActionEditar(params.value, true, false)}
            >
              <DynamicIcon
                nameIcon="EditRounded"
                size={25}
                className="dark:text-white text-primary-green"
              />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={25}
                className="text-red-500"
              />
            </IconButton>
          </div>
        );
      },
    },
  ];
};
